<script lang="ts">
    import { faCalendar, faCalendarAlt } from '@fortawesome/free-solid-svg-icons'
    import { createEventDispatcher } from 'svelte'
    import dayjs, { weekdays } from 'dayjs'
    import _isToday from 'dayjs/plugin/isToday'
    dayjs.extend(_isToday)

    import Fa from 'svelte-fa'
    const dispatch = createEventDispatcher()

    let calendar
    export let value = null
    export let showActive = true

    $: {
        updateValue(value)
    }

    let _value = null
    let weekLabel = ['D', 'S', 'T', 'Q', 'Q', 'S', 'S']
    let days = []
    function updateValue(v) {
        //if (v === _value) return
        _value = v
        days = []
        let selected = new Date(_value)
        const localDate = new Date(selected)
        localDate.setMinutes(localDate.getMinutes() + localDate.getTimezoneOffset())
        for (let index = 0; index < 7; index++) {
            const weekDay = localDate.getDay()
            const currentValue = localDate.getDate() - weekDay + index
            const current = new Date(localDate)
            current.setDate(currentValue)
            let day = {
                label: weekLabel[current.getDay()],
                day: current.getDate(),
                active: dayjs(current).format('YYYY-MM-DD') === dayjs(localDate).format('YYYY-MM-DD') && showActive,
                today: dayjs(current).isToday(),
                date: dayjs(current).format('YYYY-MM-DD'),
            }
            days.push(day)
        }
    }

    function showCalendar() {
        calendar.showPicker()
    }

    function onChange() {
        setNewDate(_value)
    }

    function setNewDate(v: string) {
        if (!v) v = dayjs(new Date()).format('YYYY-MM-DD')
        value = v
        dispatch('change', value)
    }
</script>

<div class="root cal-nav">
    <div class="cal-nav-act">
        <button on:click={showCalendar} class="btn-calendar">
            <Fa icon={faCalendarAlt} />
            <input class="calendar" type="date" bind:this={calendar} bind:value={_value} on:change={onChange} />
        </button>
        {#each days as day}
            <button
                on:click={() => setNewDate(day.date)}
                class="{day.label === 'D' ? 'sunday' : 'weekday'} {day.today ? 'today' : ''} {day.active && showActive ? 'active' : ''}"
            >
                <div class="label">{day.label}</div>
                <div class="day">{day.day}</div>

                <div class="icon icon-{!!day.today}" />
            </button>
        {/each}
    </div>
</div>

<style>
    .calendar {
        opacity: 0;
        width: 0px;
        height: 0px;
        position: absolute;
    }

    .cal-nav-act {
        display: flex;
        justify-content: space-around;
        align-items: center;
        border-radius: 0px;
        overflow: hidden;
    }

    .cal-nav-act button:first-child {
        border-left: 0px;
        background-color: #88888888 !important;
    }
    .cal-nav-act button {
        border-radius: 0px;
        border-right: 0px;
        border-top: 0px;
        flex: 1 1 45px;
        width: 45px;
        height: 51px;
        margin: 0px;
        padding: 6px 0px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: relative;
        background-color: #88888810;
        color: white;
        border: unset;
    }

    .cal-nav-act button .label {
        font-size: 11px;
        margin-top: -2px;
        opacity: 0.7;
    }

    .cal-nav-act button .day {
        font-size: 15px;
        margin-top: -4px;
        font-weight: bold;
    }
    .cal-nav-act .icon {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        flex: 0 0 auto;
        opacity: 0;
    }
    .cal-nav-act .today .icon {
        background-color: #fff;
        opacity: 1;
    }
    .cal-nav-act .active {
        background-color: #fff;
        color: #333 !important;
        border-radius: 6px;
    }
    .cal-nav-act .active .icon {
        background-color: #999999aa;
    }
    .cal-nav-act .sunday {
        color: yellow;
    }
    .cal-nav .weekday {
    }

    .cal-nav .btn-calendar {
        font-size: 20px;
    }
</style>
